import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import TermsContent from "src/components/policies/TermsContent";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// The policy text is a server component (see TermsContent): rendered once per request in the RSC
// environment and streamed to the page, without its Markdown renderer in the client bundle.
const getTermsContent = createServerFn({ method: "GET" }).handler(() =>
  renderCachedServerComponent("policy:terms", () =>
    renderServerComponent(withHydrationMarker(<TermsContent />)),
  ),
);

export const Route = createFileRoute("/_policies/terms")({
  loader: () => getTermsContent(),
  // The text only changes with a deploy.
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Terms of service",
      description:
        "Read the terms for using the CalmLens portal, API, content moderation, storage and content delivery services.",
      alternates: { canonical: "/terms" },
    }),
  component: TermsPage,
});

function TermsPage() {
  return <>{Route.useLoaderData()}</>;
}
